import React, { useState, useEffect } from 'react';
import { Box, VStack, Center, ScrollView, Image, Pressable } from 'native-base';
import { AppRouteProps, useAppNavigate } from '~/pages';
import CardMenu from './components/CardMenu';
import {
    useSpringBigStore,
    NavigationItem,
    useTheme,
    useQaAgent,
    activateChangeEnv,
    resizedUrl,
} from '@springbig/shared';
import { generatePath } from '~/utils/url';
import { Txt } from '~/shared/Typography';

type SideMenuScreenProps = {
    toggleMenu: () => void;
};

const useDevActions = () => {

    const { navigate } = useAppNavigate();
    const { isQaAgent } = useQaAgent();

    const onPress = () => {

        if (isQaAgent) {
            navigate('auth/select-env');
            return;
        }

        navigate('auth/secret-pin');
    };

    return () => activateChangeEnv(onPress);
};

const SideMenuScreen = (props: SideMenuScreenProps) => {

    const [links, setLinks] = useState<Array<NavigationItem>>([]);
    const { member, merchant } = useSpringBigStore();
    const { params } = useAppNavigate();

    const {
        menu_background_primary,
        footer_length,
        logo,
        navigation,
    } = useTheme();

    useEffect(() => {

        if (member) {

            const conditions = {
                Subscriptions: member.subscriptions_enabled,
                SpringbigPay: member.gift_card_enabled,
                Milestones: member.show_milestones,
                Rewards: member.show_rewards,
                Cart: member.merchant_website?.length > 0,
                Refer: member.referrals?.active,
                Shop: merchant?.dutchie_plus_enabled,
            };

            let _items = navigation.filter(item => conditions[item.toScreen] !== false);

            _items = _items.filter(
                (item) =>
                    item.index >= footer_length &&
                    item?.toScreen?.toString() !== "LocationStore",
            );

            setLinks(_items);
        }
    }, [member]);

    const onPress = useDevActions();
    const { isQaAgent } = useQaAgent();
    const { apiEnv } = useSpringBigStore();

    return (
        <Box
            flex={1}
            justifyContent={'center'}
            w={'100%'}
        >
            <ScrollView flex={1} bg={menu_background_primary}>
                <Center>
                    <Pressable onPress={onPress} position={'relative'} w={'100%'}>
                        { isQaAgent &&
                            <Txt position={'absolute'} p={2} fontSize={10} color={'primary'}>
                                { apiEnv }
                            </Txt>
                        }
                        <Image
                            src={resizedUrl(logo?.url, 140, 300)}
                            h={'140px'}
                            resizeMode={'contain'}
                        />
                    </Pressable>
                    <VStack pt={4} space={4} w={'100%'}>
                        { links && links.length > 0 && links.map((link, index) => {

                            const path = link.path && generatePath(link.path, params.wallet_id!) || link.toUrl;
                            const title = (link.customLabel || link.toScreen);

                            if (!title) {
                                return;
                            }

                            return (
                                <CardMenu
                                    path={path as AppRouteProps}
                                    title={title}
                                    testID={title}
                                    toggleMenu={props.toggleMenu}
                                    key={index}
                                />
                            );
                        })}
                    </VStack>
                </Center>
            </ScrollView>
        </Box>
    );
};

export default SideMenuScreen;
